import { PropsWithChildren } from 'react';

import { Box } from '@betterment/samba-react';
import { SystemStyleObject } from '@betterment/samba-styled-system/types';

import { ExpandableDetail } from '../expandable-detail/ExpandableDetail';

interface TaxImpactPreviewGainsAllowanceProps extends PropsWithChildren {
  css?: SystemStyleObject;
}

export function TaxImpactGainsAllowance({ children, css }: TaxImpactPreviewGainsAllowanceProps) {
  return (
    <ExpandableDetail>
      <Box css={css} data-testid="gains-allowance">
        {children}
      </Box>
    </ExpandableDetail>
  );
}
